import { useDataProvider } from "react-admin";
import { useQuery } from "react-query";

export const TAX_POSTING_MODE_AUTOMATIC = "AUTOMATIC";
export const TAX_POSTING_MODE_MANUAL = "MANUAL";

const SETTINGS_TAX_POSTING_MODE_RESOURCE = "settings/tax-posting-mode";

const normalizeTaxPostingMode = (value) => {
  if (typeof value !== "string") {
    return TAX_POSTING_MODE_MANUAL;
  }

  const normalized = value.trim().toUpperCase();
  if (normalized === TAX_POSTING_MODE_AUTOMATIC) {
    return TAX_POSTING_MODE_AUTOMATIC;
  }

  return TAX_POSTING_MODE_MANUAL;
};

const parseTaxPostingMode = (raw) => {
  if (typeof raw === "string") {
    return normalizeTaxPostingMode(raw);
  }

  if (raw && typeof raw === "object") {
    if (typeof raw.mode === "string") {
      return normalizeTaxPostingMode(raw.mode);
    }

    if (typeof raw.value === "string") {
      return normalizeTaxPostingMode(raw.value);
    }
  }

  return TAX_POSTING_MODE_MANUAL;
};

const useTaxPostingMode = () => {
  const dataProvider = useDataProvider();

  const { data, isLoading, error } = useQuery(
    [SETTINGS_TAX_POSTING_MODE_RESOURCE, "getListNoParams"],
    () => dataProvider.getListNoParams(SETTINGS_TAX_POSTING_MODE_RESOURCE),
    {
      staleTime: 5 * 60 * 1000,
    }
  );

  const taxPostingMode = parseTaxPostingMode(data);

  return {
    taxPostingMode,
    isManualTaxPosting: taxPostingMode === TAX_POSTING_MODE_MANUAL,
    isLoading,
    error,
  };
};

export default useTaxPostingMode;
